export class DownloaderMessages {
  public XML = 'downloader.XML';
  public detailed = 'downloader.detailed';
  public diagnostic = 'downloader.diagnostic';
  public download = 'downloader.download';
  public simple = 'downloader.simple';
  public validation = 'downloader.validation';

  constructor() {
  }
}
